import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TdLoadingService } from '@covalent/core/loading';
import { Observable, Subject } from 'rxjs';
import { UserViewModel } from 'src/view-models/user-view-model';
import { FlightLogHighlightsViewModel } from '../../../../view-models/flight-log-highlights-view-model';
import { USER } from '../../../core/user.service';
import { FlightLogSummarySortableField } from '../../flight-log-api/flight-logs/flight-log-client.model';
import { FlightLogSummaryTableSort } from '../flight-log-summaries-table/flight-log-summaries-table.component';

export type FlightLogHighlightsTableColumn =
  | 'flightTime'
  | 'flightTagNumber'
  | 'flightSummaryId'
  | 'status'
  | 'flightStatus'
  | 'flightType'
  | 'tailNumber'
  | 'pilotInCommand'
  | 'base'
  | 'actions';

@Component({
  selector: 'fl-flight-log-highlights-table',
  templateUrl: './flight-log-highlights-table.component.html',
  styleUrls: ['./flight-log-highlights-table.component.scss'],
})
export class FlightLogHighlightsTableComponent implements OnInit, OnDestroy {
  public loadingKey = 'flight-log-highlights-table';
  @Input()
  public flightLogs: Observable<FlightLogHighlightsViewModel[]>;

  public _onDestroy$ = new Subject();

  @Input()
  public total = 0;

  @Input()
  public pageSize = 50;

  @Input()
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  @Input() public columns: FlightLogHighlightsTableColumn[];

  @Output()
  public page = new EventEmitter<PageEvent>();

  @Output()
  public sort = new EventEmitter<FlightLogSummaryTableSort>();

  @Output()
  public flightLogDeleted = new EventEmitter();

  @Output()
  public flightLogRestored = new EventEmitter();

  get displayedColumns() {
    return this.columns.filter((c) => {
      if (!this.features.flightTagNumber && c === 'flightTagNumber') {
        return false;
      }
      return true;
    });
  }

  get features() {
    return this._user.flightLogFeatures;
  }

  constructor(@Inject(USER) private _user: UserViewModel, private _loading: TdLoadingService) {}

  public markAsLoading() {
    this._loading.register(this.loadingKey);
  }

  public markAsLoaded() {
    this._loading.resolveAll(this.loadingKey);
  }

  public ngOnInit() {
    this.markAsLoading();
  }

  public onFlightLogDeleted() {
    this.flightLogDeleted.emit();
  }

  public onFlightLogRestored() {
    this.flightLogRestored.emit();
  }

  public onPage(pageEvent: PageEvent) {
    this.page.emit(pageEvent);
  }

  public onSortChange({
    active,
    direction,
  }: {
    active: FlightLogSummarySortableField;
    direction: 'asc' | 'desc' | '';
  }) {
    this.sort.emit({
      orderBy: active,
      direction,
    });
  }

  public ngOnDestroy() {
    this._onDestroy$.next();
  }
}
